import React from "react";
import { Box, Card, CardContent, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

/**
 * CheckoutStepperHeader
 * Props:
 *   step: 0 | 1 | 2 (0=Checkout, 1=Payment, 2=Get token)
 */
export default function CheckoutStepperHeader({ step = 0 }) {
  const { t } = useTranslation("common");
  // Step widths: 0=33%, 1=66%, 2=100%
  const stepWidths = ["33%", "66%", "100%"];
  return (
    <Card
      elevation={8}
      sx={{
        borderRadius: 3,
        overflow: "hidden",
        bgcolor: "#FFFFFF",
        mt: { xs: 10, sm: 12, md: 4 },
        boxShadow: "0px 24px 80px rgba(15, 23, 42, 0.20)",
      }}
    >
      <CardContent sx={{ px: 4, py: 3.5 }}>
        <Typography
          variant="h5"
          sx={{ fontWeight: 700, mb: 0.5, color: "#111827" }}
        >
          {t("checkout.title", "Checkout")}
        </Typography>
        <Typography
          variant="body2"
          sx={{ color: "#6B7280", mb: 3 }}
        >
          {t(
            "checkout.reviewAndSign",
            "Review your orders and complete the payment"
          )}
        </Typography>

        {/* Simple 3-step progress “slider” */}
        <Box sx={{ mb: 1.5 }}>
          <Box
            sx={{
              position: "relative",
              height: 6,
              borderRadius: 999,
              bgcolor: "#E5E7EB",
            }}
          >
            <Box
              sx={{
                position: "absolute",
                left: 0,
                top: 0,
                bottom: 0,
                width: stepWidths[step],
                borderRadius: 999,
                bgcolor: "#2563EB",
                transition: "width 0.4s cubic-bezier(.4,1.3,.6,1)",
              }}
            />
          </Box>
        </Box>
        <Stack
          direction="row"
          justifyContent="space-between"
          sx={{ mt: 0.5}}
        >
          <Typography
            variant="caption"
            sx={{ fontSize: 12, color: step === 0 ? "#111827" : "#6B7280", fontWeight: 600 }}
          >
            {t("checkout.stepCheckout", "Checkout")}
          </Typography>
          <Typography
            variant="caption"
            sx={{ fontSize: 12, color: step === 1 ? "#111827" : "#6B7280" }}
          >
            {t("checkout.stepPayment", "Payment")}
          </Typography>
          <Typography
            variant="caption"
            sx={{ fontSize: 12, color: step === 2 ? "#111827" : "#6B7280" }}
          >
            {t("checkout.stepGetToken", "Get token")}
          </Typography>
        </Stack>
      </CardContent>
    </Card>
  );
}
